import { c as _c } from "react/compiler-runtime";
import { BenefitTiles } from '@/components/tiles';
import { IconTile } from '@/components/IconTile';
import { Trans, useTranslation } from 'react-i18next';
import React, { ReactNode } from 'react';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconShieldCheck from '@/assets/icons/heroIcons/ShieldCheck.svg';
import IconPay from '@/assets/icons/heroIcons/Pay.svg';
import IconClipboardList from '@/assets/icons/heroIcons/ClipboardList.svg';
import IconStore from '@/assets/icons/heroIcons/Store.svg';
import { Link } from '@/components/links';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import { SectionHeadline } from '@/components/SectionHeadline';
function TileContent(t0) {
  const $ = _c(5);
  const {
    title,
    text
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <b className="mb-1 block text-base lg:text-xl">{title}</b>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== text) {
    t2 = <>{t1}{text}</>;
    $[2] = t1;
    $[3] = text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function ShopSafely() {
  const $ = _c(72);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["shopWisely"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("shopSafely.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mx-auto max-w-142" anchorKey="shopSafely.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("shopSafely.items.1.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("shopSafely.items.1.text");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <TileContent title={t3} text={t4} />;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconTile icon={<IconDeferredPayment />} />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5) {
    t7 = {
      title: t5,
      icon: t6
    };
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("shopSafely.items.2.title");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Link analyticsParam="shopWiselyPackages" testId="shopWiselyPackages" to={LINKS().packages} />;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = <Trans t={t} i18nKey="shopSafely.items.2.text">{t9}</Trans>;
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t8) {
    t11 = <TileContent title={t8} text={t10} />;
    $[20] = t10;
    $[21] = t8;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <IconTile icon={<IconShieldCheck />} />;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11) {
    t13 = {
      title: t11,
      icon: t12
    };
    $[24] = t11;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t) {
    t14 = t("shopSafely.items.4.title");
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t) {
    t15 = t("shopSafely.items.4.text");
    $[28] = t;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t14 || $[31] !== t15) {
    t16 = <TileContent title={t14} text={t15} />;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <IconTile icon={<IconPay />} />;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t16) {
    t18 = {
      title: t16,
      icon: t17
    };
    $[34] = t16;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t) {
    t19 = t("shopSafely.items.5.title");
    $[36] = t;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t) {
    t20 = t("shopSafely.items.5.text");
    $[38] = t;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t19 || $[41] !== t20) {
    t21 = <TileContent title={t19} text={t20} />;
    $[40] = t19;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <IconTile icon={<IconClipboardList />} />;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t21) {
    t23 = {
      title: t21,
      icon: t22
    };
    $[44] = t21;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t) {
    t24 = t("shopSafely.items.7.title");
    $[46] = t;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Link analyticsParam="shopWiselyWhereToShop" testId="shopWiselyWhereToShop" to={LINKS().whereToShop} />;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t) {
    t26 = <Trans t={t} i18nKey="shopSafely.items.7.text">{t25}</Trans>;
    $[49] = t;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== t24 || $[52] !== t26) {
    t27 = <TileContent title={t24} text={t26} />;
    $[51] = t24;
    $[52] = t26;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <IconTile icon={<IconStore />} />;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== t27) {
    t29 = {
      title: t27,
      icon: t28
    };
    $[55] = t27;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  let t30;
  if ($[57] !== t13 || $[58] !== t18 || $[59] !== t23 || $[60] !== t29 || $[61] !== t7) {
    t30 = <BenefitTiles background="bg-white" classNameTitle="text-sm lg:text-base" classNameItem="md:h-30" items={[t7, t13, t18, t23, t29]} />;
    $[57] = t13;
    $[58] = t18;
    $[59] = t23;
    $[60] = t29;
    $[61] = t7;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  let t31;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = LINKS();
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  const t32 = t31.registration;
  let t33;
  if ($[64] !== t) {
    t33 = t("shopSafely.cta");
    $[64] = t;
    $[65] = t33;
  } else {
    t33 = $[65];
  }
  let t34;
  if ($[66] !== t33) {
    t34 = <Button to={t32} testId="shopWiselyRegistration" analyticsParam="shopWiselyRegistration" variant="primary" align="center" size="lg">{t33}</Button>;
    $[66] = t33;
    $[67] = t34;
  } else {
    t34 = $[67];
  }
  let t35;
  if ($[68] !== t2 || $[69] !== t30 || $[70] !== t34) {
    t35 = <div className="flex flex-col gap-12 px-4 lg:gap-16">{t2}{t30}{t34}</div>;
    $[68] = t2;
    $[69] = t30;
    $[70] = t34;
    $[71] = t35;
  } else {
    t35 = $[71];
  }
  return t35;
}